module.exports = __webpack_public_path__ + "static/media/123.d985037b.png";